export default __webpack_public_path__ + "static/media/badcrewkor.1d51cc2a.svg";